import React from 'react';
import ContractEthereumBalance from './ContractEthereumBalance';
import GetEther from './GetEther';
import GiveEther from './GiveEther';

export default class EtherPage extends React.Component {
  render () {
    return (
      <div className="c-ether-page">
        <h1>Get Ether</h1>
        <ContractEthereumBalance/>
        <div className="c-components">
          <GiveEther/>
          <GetEther/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EtherPage/EtherPage.js